import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export default function MegaMenu({ category, items = [], visible }) {
    if (!visible || items.length === 0) return null;

    return (
        <div className="absolute left-0 w-full bg-white shadow-lg border-t mt-1 px-5 py-4 z-50">

            {/* CATEGORY TITLE (BLACK BACKGROUND ONLY) */}
            <h3
                className="
                    inline-block
                    bg-black
                    text-white
                    text-sm
                    font-bold
                    mb-3
                    px-3
                    py-1
                    rounded
                "
            >
                {category}
            </h3>

            <Swiper
                modules={[Navigation]}
                navigation
                spaceBetween={16}
                slidesPerView={3}
                breakpoints={{
                    320: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1280: { slidesPerView: 4 },
                }}
            >
                {items.map((article) => (
                    <SwiperSlide key={article.slug}>
                        <Link
                            to={`/article/${article.slug}`}
                            className="block group"
                        >
                            {/* IMAGE */}
                            <div className="w-full h-[140px] bg-gray-200 rounded-md overflow-hidden">
                                <img
                                    src={
                                        article.images ||
                                        "https://via.placeholder.com/400x250"
                                    }
                                    alt={article.title}
                                    className="
                                        w-full h-full object-cover
                                        transition-transform duration-300
                                        group-hover:scale-105
                                    "
                                />
                            </div>

                            {/* TITLE (BLACK BACKGROUND ONLY) */}
                            <p
                                className="
                                    mt-2
                                    text-[15px]
                                    font-medium
                                    leading-snug
                                    line-clamp-7
                                    bg-white
                                    text-black
                                    px-2
                                    py-1
                                    rounded
                                "
                            >
                                {article.title}
                            </p>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
